export default class ChartOptions {
  events:any;
  plugins: any;
  scales: any;
  elements: any;
  maintainAspectRatio: any;
  constructor() {
    this.plugins = {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          font: {
            family: 'montserrat'
          }
        }
      },
      tooltip: {
        mode: 'index',
        callbacks: {
          
        }
      }
    };
    this.scales = {
      xAxis: {
        grid: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          font: {
            family: 'montserrat',
            size: 10
          }
        },
        chartAreaBorder: {
          borderWidth: 1
        }
      },
      yAxis: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            family: 'montserrat',
            size: 10
          }
        }
      },
      y0: {
        // Place holder in case we need multiple y axis
        grid: {
          drawOnChartArea: false,
        },
        position: 'left',
        ticks: {
          font: {
            family: 'montserrat',
            size: 10
          }
        },
        display: false,
      },
      y1: {
        // Place holder in case we need multiple y axis
        grid: {
          drawOnChartArea: false,
        },
        position: 'right',
        ticks: {
          font: {
            family: 'montserrat',
            size: 10
          }
        },
        display: false,
      },
    };
    this.elements = {
      line: {
        fill: false
      },
      point: {
        radius: 0,
        hitRadius: 20
      }
    };
    this.maintainAspectRatio = false
  }
}
